export const getRoleChoices = translate => [
    { id: 'ROLE_CLIENT', name: translate('resources.user.choices.role.ROLE_CLIENT') },
    { id: 'ROLE_CLIENT_MASTER', name: translate('resources.user.choices.role.ROLE_CLIENT_MASTER') },
    { id: 'ROLE_SERVICE', name: translate('resources.user.choices.role.ROLE_SERVICE') },
    { id: 'ROLE_SERVICE_MASTER', name: translate('resources.user.choices.role.ROLE_SERVICE_MASTER') },
    { id: 'ROLE_ADMIN', name: translate('resources.user.choices.role.ROLE_ADMIN') },
    { id: 'ROLE_BOK', name: translate('resources.user.choices.role.ROLE_BOK') },
    { id: 'ROLE_POS_OWNER', name: translate('resources.user.choices.role.ROLE_POS_OWNER') },
];

export const getClientRoleChoices = translate => [
    { id: 'ROLE_CLIENT', name: translate('resources.user.choices.role.ROLE_CLIENT') },
    { id: 'ROLE_CLIENT_MASTER', name: translate('resources.user.choices.role.ROLE_CLIENT_MASTER') },
    { id: 'ROLE_POS_OWNER', name: translate('resources.user.choices.role.ROLE_POS_OWNER') },
];

export const getServiceRoleChoices = translate => [
    { id: 'ROLE_SERVICE', name: translate('resources.user.choices.role.ROLE_SERVICE') },
    { id: 'ROLE_SERVICE_MASTER', name: translate('resources.user.choices.role.ROLE_SERVICE_MASTER') },
];
